<template>
    <div class="col-md-12">
        <button class="btn btn-success" style="border-radius: 2px !important;" @click="openModal()">
            <i class="fas fa-clipboard-check"></i> Adicionar novo status
        </button>

        <b-row>
            <b-col md="12">
                <b-table striped hover bordered sort-icon-left show-empty :items="tbData" :fields="fields"
                    :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered"
                    :current-page="currentPage" :per-page="perPage" thead-class="font-weight-bold">

                    <template v-if="loading" #empty>
                        <div class="text-center">
                            <b-spinner variant="dark" small></b-spinner> Processando, por favor, aguarde...
                        </div>
                    </template>

                    <template v-else #empty>
                        <h6 style="text-align: center">Nenhum resultado encontrado.</h6>
                    </template>

                    <template #cell(is_finisher)="data">
                        {{ data.item.is_finisher ? "✅ Finaliza" : "⛔ Não Finaliza" }}
                    </template>

                    <template #cell(createdAt)="data">
                        {{ handleCreatedAt(data.item.createdAt, data.item.immutable) }}
                    </template>

                    <template #cell(name)="data">
                        <span class="highlight-badge" :style="dinamicStyle(data.item.color)">{{ data.item.name }}</span>
                    </template>

                    <template v-slot:cell(view-button)="{ item }">
                        <span>
                            <b-btn id="view-button" @click.prevent="handleViewClick(item)" style="border-radius: 3px !important;">
                                <i class="far fa-eye" aria-hidden="true"></i>
                            </b-btn>
                        </span>
                    </template>
                </b-table>
            </b-col>
        </b-row>

        <b-row class="justify-content-between">
            <b-col md="4">
                <b-form-group label="Registros por página" label-for="per-page-select" label-cols-md="6" label-align-sm="right"
                    label-size="sm" class="mb-0 align-self-center">
                    <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions"></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="7" md="6" class="my-1">
                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="right" size="md"
                    class="my-0"></b-pagination>
            </b-col>
        </b-row>

        <StatusTaskModal ref="addStatus" @updateStatusTable="updateTable"></StatusTaskModal>
    </div>
</template>

<script>
import StatusTaskModal from './StatusTaskModal.vue';
import { dinamicStyle, formatDate, handleCreatedAt } from '../../../helpers/utils';
import { taskManagerAxios } from '../connections/taskApiConnection';

export default {
    name: "ManageTaskStatus",
    components: { StatusTaskModal },
    data() {
        return {
            tbData: [],
            loading: false,
            fields: [
                {
                    key: 'createdAt',
                    label: 'Data',
                    sortable: true,
                    class: 'text-center',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'name',
                    label: 'Nome',
                    sortable: true,
                    class: 'text-center',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'is_finisher',
                    label: 'Finalizador',
                    sortable: true,
                    class: 'text-center',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'view-button',
                    label: 'Visualizar',
                    sortable: false,
                    class: 'text-center',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff', width: '100px' }
                },
            ],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15, { value: 100, text: "Ver mais" }],
            sortBy: '',
            sortDirection: 'asc',
            filter: null,
            filterOn: [],
        }
    },
    created() {
        this.getDataTable();
    },
    methods: {
        formatDate,
        dinamicStyle,
        handleCreatedAt,
        openModal(value = null) {
            this.$refs.addStatus.openModal(value);
        },
        handleViewClick(item) {
            if (item.tag !== 'co') {
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    type: "error",
                    title: 'Sem permissão para editar este status',
                    showConfirmButton: false,
                    timer: 3000
                });
                return;
            }
            this.openModal(item);
        },
        getDataTable() {
            taskManagerAxios.get('/statuses')
                .then(({ data }) => {
                    this.tbData = data;
                    this.totalRows = data.length;
                })
                .catch((error) => console.error(error));
        },
        updateTable(data) {
            if (!data._id) return;
            const found = this.tbData.find(el => el._id === data._id);
            if (found) {
                Object.assign(found, data);
            } else {
                this.tbData.push(data);
            }
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
    }
}
</script>

<style scoped>
.highlight-badge {
    padding: 5px 10px;
    border-radius: 5px !important;
    font-weight: bold;
}
</style>
